import { get, put } from '../../../util/fetch';
import { RoleType } from '../../types/RoleType';
import { UseType } from '../../types/UseType';
import {
  AdministratorOptionDto,
  GetAdministratorAccessLogsRs,
  GetAdministratorAccountLogsRs,
  GetAdministratorsRs,
} from './rs';

export interface AdministratorFilter {
  keyword?: string;
  roleType?: string;
  useType?: string;
  locked?: string;
}

const toQuery = (filter: object, page: number, size: number) => {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') params.append(key, String(value).trim());
  });
  return params.toString();
};

export const getAdministrators = (filter: AdministratorFilter, page: number, size: number) => {
  return get<GetAdministratorsRs>(`/api/v1/administrators?${toQuery(filter, page, size)}`);
};

export const getAdministratorOptions = () => {
  return get<AdministratorOptionDto[]>('/api/v1/administrators/options');
};

export const putAdministratorRoleType = (id: number, roleType: RoleType) => {
  return put(`/api/v1/administrators/${id}/role-type`, { roleType });
};

export const putAdministratorUseType = (id: number, useType: UseType) => {
  return put(`/api/v1/administrators/${id}/use-type`, { useType });
};

export const putAdministratorUnlock = (id: number) => {
  return put(`/api/v1/administrators/${id}/unlock`);
};

export interface AdministratorAccountLogFilter {
  fromDate?: string;
  toDate?: string;
  administratorId?: number;
  actionType?: string;
}

export const getAdministratorAccountLogs = (filter: AdministratorAccountLogFilter, page: number, size: number) => {
  return get<GetAdministratorAccountLogsRs>(`/api/v1/administrators/account-logs?${toQuery(filter, page, size)}`);
};

export interface AdministratorAccessLogFilter {
  fromDate?: string;
  toDate?: string;
  administratorId?: number;
  actionType?: string;
}

export const getAdministratorAccessLogs = (filter: AdministratorAccessLogFilter, page: number, size: number) => {
  return get<GetAdministratorAccessLogsRs>(`/api/v1/administrators/access-logs?${toQuery(filter, page, size)}`);
};
